import "core-js";
import * as $ from "jquery";
import { AuthenticationHandler } from "../common/authentication-handler";
import { Pwa } from "./pwa";
import { Application } from "./application";
import { C } from "../common/component";
import { Loader } from "../common/loader";
import { Form, FormDisplayer } from "../forms/form";
import { DomainHelper } from "../common/domain-helper";
import { VersionChecker } from "../common/version-checker";
import { Language, TxtInitialize } from "../common/text";

window["jQuery"] = $;
require("bootstrap");
require("datatables.net-bs");
require("datatables.net-buttons-bs");
require("datatables.net-fixedheader-bs");
require("datatables.net-responsive-bs");

if ("serviceWorker" in navigator)
{
    window.addEventListener("load", function ()
    {
        navigator.serviceWorker.register("/sw.js").then(function (registration)
        {
            console.log("ServiceWorker registration successful with scope: ", registration.scope);
        }, function (err)
        {
            console.log("ServiceWorker registration failed: ", err);
        });
    });
    window.addEventListener("beforeinstallprompt", function (e)
    {
        e.preventDefault();
        Pwa.deferredPrompt = e;
    });
}

$(async () =>
{
    VersionChecker.loadInitialVersion();
    $.ajaxSetup({
        beforeSend(xhr)
        {
            xhr.setRequestHeader(AuthenticationHandler.controlTokenParamName, localStorage[AuthenticationHandler.controlTokenParamName]);
        }
    });
    C.body.addClass("scrollbar");
    Loader.initializeGlobalLoader();
    // Hack to prevent Chrome autofilling random textboxes with username
    C.body.append(C.input.attr("type", "text").attr("id", "username").css("display", "none"));

    if (await AuthenticationHandler.isLoggedIn())
    {
        if (window.location.hostname === "user.wemply.com")
        {
            await AuthenticationHandler.logout();
            location.reload();
        }
        else
        {
            Loader.startGlobally(true);
            try
            {
                await Application.initialize();
            }
            finally
            {
                Loader.stopGlobally();
            }
        }
    }
    else
    {
        const urlParams = new URLSearchParams(window.location.search);
        const newEmployeeAuthToken = urlParams.get("newEmployee");
        if (newEmployeeAuthToken)
        {
            await TxtInitialize(urlParams.get("language") ?? Language.estonian);
            const formUrl = "public/newEmployeeForm?authToken=" + newEmployeeAuthToken + "&company=" + DomainHelper.getDomain();
            await FormDisplayer.addForm(new Form(formUrl), C.body);
        }
        else
        {
            window.location.replace(window.location.origin + "/auth.html" + window.location.search + window.location.hash);
        }
    }
});

